import { business } from '../data/site'

const defaultMessage =
  'Hola Flores con Aroma de Café, me gustaría cotizar flores y/o globos para mi evento.'

export function whatsappLink(message: string = defaultMessage): string {
  return `https://wa.me/${business.whatsappNumber}?text=${encodeURIComponent(message)}`
}
